export default `vec3 v=vec3(0.0,1.5,6.3);
    return min(6.-length((p-v).xy+sin(p.yx)),
      dot(cos(p),sin(p.yzx)))+sin(sin(p.z*3.5)+v.z)*.1+1.;
  }`